import {RouterModule, Routes} from '@angular/router';
import {CourseComponent} from './course.component';
import {NgModule} from '@angular/core';
import {CommonModule, DatePipe} from '@angular/common';
import {
  CourseNavigationModule,
  HeroImageModule,
  SliderModule,
  SubscriptionFormModule
} from '../../../shared/components';
import {FileModule} from '../../../shared/pipes';
import {TranslateModule} from '@ngx-translate/core';
import {NoAccessDialogComponent} from './no-access-dialog/no-access-dialog.component';
import { DialogModule } from '../../../shared/modules';

const routes: Routes = [
  {path: '', component: CourseComponent},
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    SliderModule,
    FileModule,
    SubscriptionFormModule,
    CourseNavigationModule,
    TranslateModule,
    DialogModule,
    HeroImageModule
  ],
  declarations: [CourseComponent, NoAccessDialogComponent],
  providers: [
    DatePipe
  ]
})
export class CourseModule {
}
